import { inject, Injectable } from '@angular/core';
import {CrudService} from './crud.service';
import {CreateUserPayload, UpdateUserPayload, User, type FinalizeUserPayload} from '../interfaces/user';
import {mergeMap, Observable, of, take, tap} from 'rxjs';
import {environment} from '../../environment/environment';
import {ApiResponse, Brand, FaviconUrl, SystemTitle} from '../interfaces/application';
import { AuthService } from './auth.service';
import { LayoutService } from './layout.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends CrudService<User, CreateUserPayload, UpdateUserPayload>{

  private readonly _layoutService: LayoutService = inject(LayoutService);
  private readonly _authService: AuthService = inject(AuthService);

  constructor() {
    super('users');
  }

  public me(): Observable<ApiResponse<User>> {
    return this._authService.userAuthenticated()
      .pipe(
        take(1),
        mergeMap((user: User|null) => {
          if (user) {
            return of({
              success: true,
              message: 'Usuário localizado',
              data: user
            });
          }

          return this._http.get<ApiResponse<User>>(`${environment.api}/${this.path}/me`)
            .pipe(
              tap(response => this._layoutService.initUpdateColors(response.data.brand)),
              tap(response => {
                switch (response.data.brand) {
                  case Brand.LOGAME:
                    this._layoutService.changeFavicon(FaviconUrl.LOGAME);
                    this._layoutService.setSystemTitle(SystemTitle.LOGAME);
                    break;
                  case Brand.B2XBET:
                    this._layoutService.changeFavicon(FaviconUrl.B2XBET);
                    this._layoutService.setSystemTitle(SystemTitle.B2XBET);
                    break;
                  case Brand.LIDERBET:
                    this._layoutService.changeFavicon(FaviconUrl.LIDERBET);
                    this._layoutService.setSystemTitle(SystemTitle.LIDERBET);
                    break;
                  case Brand.GERALBETR2M:
                  case Brand.GERALBET:
                    this._layoutService.changeFavicon(FaviconUrl.GERALBET);
                    this._layoutService.setSystemTitle(SystemTitle.GERALBET);
                    break;
                }
              }),
              tap(response => this._authService.setUserAuthenticated(response.data)),
            );
        })
      );
  }

  public finalize(code: string, user: FinalizeUserPayload): Observable<ApiResponse<User>> {
    return this._http.post<ApiResponse<User>>(`${environment.api}/${this.path}/${code}/finalize`, user);
  }

  public resendInviteEmail(id: string): Observable<ApiResponse<void>> {
    return this._http.post<ApiResponse<void>>(`${environment.api}/${this.path}/${id}/resend-invite-email`, {});
  }
}
